<template>
    <div>
        <div class="text-right mb-2" v-if="showViewSelector">
            <i class="fas fa-list pointer" @click="view='table'"></i>
            <i class="fas fa-th-large pointer" @click="view='tickets'"></i>
        </div>
        <div>
            <group v-for="group in sortedGroups" :group="group" :view="view"></group>
        </div>
    </div>
</template>

<script>

import Group from "./Group";
import {isMobile} from "../../Utility/mixins/isMobile";

export default {
    name: "ticket-list",
    components: {
        Group
    },
    mixins: [isMobile],
    props: {
        groups: {
            type: Array,
            default: () => {
                []
            },
            required: true,
        }
    },
    computed: {
        sortedGroups() {
            return this.groups.sort((a, b) => a.title.localeCompare(b.title));
        },
        allRegistrationCategories() {
            return this.combineObjectFromArrayKey(this.groups, 'registration_categories');
        },
        showViewSelector() {
            return this.allRegistrationCategories.length > 1 && !this.isMobile;
        }
    },
    data() {
        return {
            view: 'tickets'
        }
    },
    watch: {
        isMobile: {
            handler: function (newVal) {
                if (this.view === 'table' && newVal) {
                    this.view = 'tickets';
                }
            },
            immediate: true
        }
    },
    methods: {
        combineObjectFromArrayKey(arrays, keyToCombine) {
            // Initialize an empty array to store the combined objects.
            const combinedArray = [];

            // Iterate through each array in the input arrays.
            arrays.forEach((array) => {
                // Find the object with the specified key within the current array.
                const foundObject = array[keyToCombine];

                // If the object is found, add it to the combined array.
                if (foundObject) {
                    combinedArray.push(foundObject);
                }
            });

            return combinedArray;
        }
    }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/List.vue